import React, { Component } from 'react'
import { connect } from 'react-redux'
import QuillEditor from '../../../Components/Editors/QuillEditor'
import { setEditorState, resetEditorState, addImageLink } from 'store/actions/mailFooterAction'
import { saveEditorState } from 'firebase/database/mailFooterHandler'
import Button from '@material-ui/core/Button'
import {deleteFilesByPath} from '../../../firebase/storage/deleteFiles'
import Loading from 'Components/Loading/Spinner'
import Stack from '@mui/material/Stack';
import './editorSyles.css'
import {mailFooterImageUpload} from 'firebase/storage/uploadFiles'
import { withRouter } from 'react-router-dom'
import { compose } from 'redux'
import { dialog } from 'store/actions/dialogActions'
class MailFooterEditor extends Component {


  onEditorStateChange = (editorState) => {
    return setEditorState(editorState)
  }
  handleSaveEditorState = () => {
    return saveEditorState(
      this.props.editorState,
      this.props.isActive,
      this.props.fileLinks)
  }

  handleResetEditor =  () => {
    const resetMailFooter = () => {
        if(this.props.fileLinks.length!==0) {
        deleteFilesByPath(this.props.fileLinks)
      }
      saveEditorState('', false, [])
      resetEditorState()
      return dialog('reset')
    }
    return dialog({isOpen: true, title: 'E-Mail Footer löschen?', text: 'E-Mail Footer wird gelöscht', buttons: [{title: 'Zurück', color:'primary', onClick: ()=>dialog('reset')}, {title: 'Löschen', color: 'secondary', onClick: resetMailFooter}]})
  }
  handleImageUpload = async (file) => {

    const data = await mailFooterImageUpload(file)
    const { filePath } = data
    addImageLink(filePath)
    return data
  }

  goBack = () => {
    return this.props.history.goBack()
  }

  render() {
    return (
     <div style={this.props.isActive ? {backgroundColor: 'rgba(255, 0, 0, 0.500'} : {minHeight: '22rem', backgroundColor: 'lightblue'}} >
        {this.props.isLoaded
          ? <QuillEditor
              imageUpload={this.handleImageUpload}
              handleChangeCallback={this.onEditorStateChange}
              editorState={this.props.editorState}
              placeholder='Die Schriftgröße 12px ist die Standardgröße in den Meisten E-Mail Clients. Es wir hier in der App nur etwas kleiner dargestellt.'
            />
        : <Loading title='Lade Editor' />}
        {this.props.isLoaded && <Stack spacing={1} direction='row' style={{padding: '0.5rem'}}>
      
          <Button disabled={this.props.editorState.length<=12} size='small' onClick={this.handleSaveEditorState} variant='contained' color='primary' >Speichern</Button>
          <Button disabled={this.props.editorState.length<=12} size='small'  onClick={this.handleResetEditor} variant='contained' color='secondary' >Löschen</Button>
          <Button size='small' onClick={this.goBack} variant='outlined' color='primary' >Zurück</Button>
        </Stack>}
    </div>
    )
  }
}

export default compose(
  connect((state) => ({
    isActive: state.mailFooter.isActive,
    editorState: state.mailFooter.editorState,
    isLoaded: state.mailFooter.editorState !== null,
    fileLinks: state.mailFooter.fileLinks
  })),
  withRouter,

)(MailFooterEditor)
